/**
 * 오행(목·화·토·금·수) 디자인 시스템 색상 팔레트.
 * - color: 텍스트/아이콘 색
 * - bg: 옅은 배경 (라벨 chip 등)
 * - solid: 진한 단색 배경 (큰 색 박스 등) — 현재는 color와 동일
 */
export const OHAENG_PALETTE = {
  목: { color: '#5e9f1c', bg: 'rgba(94, 159, 28, 0.1)', solid: '#5e9f1c' },
  화: { color: '#c23535', bg: 'rgba(194, 53, 53, 0.1)', solid: '#c23535' },
  토: { color: '#db9823', bg: 'rgba(219, 152, 35, 0.1)', solid: '#db9823' },
  금: { color: '#949494', bg: 'rgba(148, 148, 148, 0.1)', solid: '#949494' },
  수: { color: '#404040', bg: 'rgba(64, 64, 64, 0.1)', solid: '#404040' },
};

const FALLBACK = OHAENG_PALETTE.금;

/** 라벨로 팔레트 조회 — 매칭되지 않으면 금(회색) 기본값 */
export const getOhaeng = (label) => OHAENG_PALETTE[label] || FALLBACK;

/**
 * 배지 데이터 정규화 — 문자열('금')이면 팔레트 룩업, 객체이면 그대로 사용.
 * API에서 라벨 배열로만 받아도 동작하도록.
 */
export const resolveOhaengBadge = (b) => {
  if (typeof b === 'string') {
    const p = getOhaeng(b);
    return { label: b, color: p.color, bg: p.bg };
  }
  if (b && b.color && b.bg) return b;
  const p = getOhaeng(b?.label);
  return { label: b?.label ?? '', color: p.color, bg: p.bg };
};
